<template>
	<FormCustomerGroup
		:is-submitting="create.isCreating"
		@onConfirm="handleConfirm"
	/>
</template>
<script>
import FormCustomerGroup from '@/components/FormCustomerGroup.vue';
import { mapActions, mapState } from 'vuex';

export default {
	name: 'CustomerGroupCreate',
	components: {
		FormCustomerGroup,
	},
	computed: {
		...mapState('customerGroups', {
			create: 'create',
		}),
	},
	methods: {
		...mapActions({
			createCustomerGroup: 'customerGroups/createCustomerGroup',
		}),
		async handleConfirm(params) {
			await this.createCustomerGroup(params);
		},
	},
};
</script>
